import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-ken-burns-preset',
  templateUrl: './ken-burns-preset.component.html',
  styleUrls: ['./ken-burns-preset.component.scss']
})
export class KenBurnsPresetComponent implements OnInit {

  public presets = [
    {
      id: 'zoom_to_center',
      title: 'Zoom to Center',
      img: 'sample_animation.gif',
      video: 'zoom_to_center.mp4',
      config: {
        scaleInFactor: 1,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1.3,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    },
    {
      id: 'zoom_out_from_center',
      title: 'Zoom Out from Center',
      img: 'zoom-out.gif',
      video: 'zoom_from_center.mp4',
      config: {
        scaleInFactor: 1.3,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    },
    {
      id: 'zoom_to_right',
      title: 'Zoom to Right',
      img: 'zoom-out.gif',
      video: 'zoom_to_right.mp4',
      config: {
        scaleInFactor: 1,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1.3,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    },
    {
      id: 'zoom_to_left',
      title: 'Zoom to Left',
      img: 'zoom-out.gif',
      video: 'zoom_to_left.mp4',
      config: {
        scaleInFactor: 1,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1.3,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    },
    {
      id: 'zoom_out_from_right',
      title: 'Zoom Out from Right',
      img: 'zoom-out.gif',
      video: 'zoom_out_from_right.mp4',
      config: {
        scaleInFactor: 1.3,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    },
    {
      id: 'zoom_out_from_left',
      title: 'Zoom Out from Left',
      img: 'zoom-out.gif',
      video: 'zoom_out_from_left.mp4',
      config: {
        scaleInFactor: 1.3,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    },
    {
      id: 'pan_right',
      title: 'Pan Right',
      img: 'slide-right.gif',
      video: 'pan_right.mp4',
      config: {
        scaleInFactor: 1.2,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1.2,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    },
    {
      id: 'pan_left',
      title: 'Pan Left',
      img: 'sample_animation.gif',
      video: 'pan_left.mp4',
      config: {
        scaleInFactor: 1.2,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1.2,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    },
    {
      id: 'tilt_up',
      title: 'Tilt Up',
      img: 'sample_animation.gif',
      video: 'tilt_up.mp4',
      config: {
        scaleInFactor: 1.2,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1.2,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    },
    {
      id: 'tilt_down',
      title: 'Tilt Down',
      img: 'sample_animation.gif',
      video: 'tilt_down.mp4',
      config: {
        scaleInFactor: 1.2,
        scaleInTime: 0,
        scaleInOffsetX: 0,
        scaleInOffsetY: 0,
        scaleOutFactor: 1.2,
        scaleOutTime: 0,
        scaleOutOffsetX: 0,
        scaleOutOffsetY: 0
      }
    }
  ];

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
  }

  selectPreset(item: any) {
    this.activeModal.close(item);
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/ken-burns-preset/ken-burns-preset.component.ts